import { FREELANCEDASHBOARDJOBCOUNT } from "../../ENVIRONMENT";

// api for freelance jobcount
function freelancejobcount(token) {
  const response = fetch(FREELANCEDASHBOARDJOBCOUNT, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freelancejobcount };
